import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class DynamicCompany implements UserProperties, UserPayments {
    constructor(
        private apis: Record<string, string>,
        public dynamicFields: DynamicField[] = [],
        public dynamicSections: DynamicSections[] = []
    ) {
        const paymentURL = this.apis['payments'];

        this.dynamicSections = [
            {
                id: 1,
                label: 'Company Customer Reference',
                orderNumber: 0,
                company: { id: 57, name: '' },
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Payment Details',
                orderNumber: 1,
                company: { id: 57, name: '' },
                emailDomain: null,
            },
            {
                id: 3,
                label: 'Customer Reference',
                orderNumber: 2,
                company: { id: 57, name: '' },
                emailDomain: null,
            },
        ];
        this.dynamicFields = [
            {
                name: 'customerRef',
                label: 'Reference',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'locationId',
                label: 'Location',
                section: 0,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                apiProviderData: `${paymentURL}/customer/approval-flow/information`,
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string): Detail[] => [
        {
            label: facility?.externalLookup ? 'File Number' : 'Second facility reference #',
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (
        payment: PaymentDetailType,
        customerReferenceLabel: string = ''
    ): Detail[] => [
        {
            label: customerReferenceLabel ? customerReferenceLabel : 'Customer Reference',
            value: payment.customerReference ? payment.customerReference : 'N/A',
            show: true,
        },
        {
            label: 'Payment Notification Email',
            value: payment.notificationEmail ? payment.notificationEmail : 'N/A',
            show: true,
        },
        { label: 'Notes', value: payment.notes ? payment.notes : 'N/A', show: true },
    ];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: true,
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: true,
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: false },
    ];
}
